<template>
    <section class="container">
        <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>

        <b-table :data="teams" v-if="teams">
            <template slot-scope="props">
                <b-table-column class="centered-table-content cell--profile-picture" field="imageUrl" label="Avatar">
                    <img :src="props.row.imageUrl"/>
                </b-table-column>

                <b-table-column class="centered-table-content" field="name" label="Team name">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column class="centered-table-content" field="score" label="Score">
                    {{ props.row.score }}
                </b-table-column>

                <b-table-column class="centered-table-content" label="Winner">
                    <b-icon :icon="props.row.isWinningTeam === true ? 'trophy' : ''" type="is-warning" size="is-large">
                    </b-icon>
                </b-table-column>

                <b-table-column class="centered-table-content" label="Certificate">
                    <b-button @click="downloadCertificates(props.row.name, props.row.score, props.row.isWinningTeam)"
                              class="button is-success is-outlined"
                              :icon-right="props.row.isWinningTeam === true ? 'trophy' : ''">Download
                    </b-button>
                </b-table-column>

            </template>
        </b-table>

        <img :src="imageRawCertificate" v-if="isImageGenerated">
    </section>
</template>

<script>
    import gameService from '../../services/gamesService'
    import displayHelper from '../../helpers/display-helper'
    import config from '../../geogaming-config'
    import selected from '../../geogaming-selected'
    import jsPDF from 'jspdf'
    import { saveAs } from 'file-saver'

const DEFAULT_CONFIG_NAME = 'default'
    const configName = selected.envName
    console.log(' > stage:' + configName)

    const DEFAULT_TITLE = config[configName] ? config[configName].title : config[DEFAULT_CONFIG_NAME].title
    const DEFAULT_IMAGE_URL = config[configName] ? config[configName].logo : config[DEFAULT_CONFIG_NAME].logo
    const DEFAULT_PROVIDER = config[configName] ? config[configName].provider : config[DEFAULT_CONFIG_NAME].provider

    const PATH_TO_CERTIFICATES_IMAGES = 'certificates/'

    export default {
      name: 'leaderboard-table',
      props: {
        isBase64ImageRequired: false,
        gameName: ''
      },
      created() {
        this.loadTeamLeaderboard()
      },
      data() {
        return {
          gameId: this.$route.params.id,
          isLoading: true,
          teams: null,

          imageRawCertificate: '',
          isImageGenerated: false,
        }
      },
      methods: {
        loadTeamLeaderboard() {
          var parent = this
          this.isLoading = true
          gameService.getLeaderBoard(this.gameId, this.isBase64ImageRequired).then((data) => {
            this.teams = data.teams
          },
                    (err) => {
                      displayHelper.displayError(parent, 'Error while displaying the leaderboard: ' + err.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
        },
        downloadCertificates(teamName, score, isWinningTeam) {
          const {createCanvas, loadImage} = require('canvas')

          let imgCertificate = isWinningTeam ? PATH_TO_CERTIFICATES_IMAGES + 'certificate-template-win.png' : PATH_TO_CERTIFICATES_IMAGES + 'certificate-template.png'
          let imgLogo = DEFAULT_IMAGE_URL

          const txtCongrats = 'Congratulations!'

          loadImage(imgCertificate).then((image) => {
            const canvas = createCanvas(image.width, image.height)
            const ctx = canvas.getContext('2d')

            ctx.drawImage(image, 0, 0)

            // Congrats
            ctx.font = '120px Impact'
            ctx.fillStyle = '#000'
            ctx.fillText(txtCongrats, Math.round((image.width - ctx.measureText(txtCongrats).width) / 2), 600)

            // Game and Provider
            ctx.font = 'italic 50px Roboto'
            ctx.fillStyle = '#CCC'
            ctx.fillText(this.gameName + ' by ' + DEFAULT_PROVIDER, 250, 300)

            // Main text
            let mainText1 = isWinningTeam ? 'Your team has won this game!' : 'Your team has done a great job!'
            let mainText2 = `Well done team ${teamName}!`
            let mainText3 = `You have scored ${score} points.`

            ctx.font = '60px Roboto'
            ctx.fillStyle = '#000'
            ctx.fillText(mainText1, Math.round((image.width - ctx.measureText(mainText1).width) / 2), Math.round((image.height - 60) / 2))
            ctx.fillText(mainText2, Math.round((image.width - ctx.measureText(mainText2).width) / 2), Math.round((image.height + 80) / 2))
            ctx.fillText(mainText3, Math.round((image.width - ctx.measureText(mainText3).width) / 2), Math.round((image.height + 240) / 2))

            // Date
            let dateOfTheGame = '21/11/2019'
            ctx.font = '40px Roboto'
            ctx.fillText(dateOfTheGame, 360 + Math.round((685 - 360 - ctx.measureText(dateOfTheGame).width) / 2), 1330)

            // Signature
            ctx.font = '40px Roboto'
            ctx.fillText(DEFAULT_PROVIDER, 1450 + Math.round((1780 - 1450 - ctx.measureText(DEFAULT_PROVIDER).width) / 2), 1330)

            // Provider logo
            var img2 = new Image()
            img2.src = imgLogo

            let w, h, A, B

            // adjustments for logo size
            if (img2.height > 180) {
              h = 180
              w = Math.round(img2.width * 180 / img2.height)
            } else {
              w = img2.width
              h = img2.height
            }

            A = 1450 + Math.round((image.width - 1450 - w - 420) / 2)
            B = image.height - h - 450

            ctx.drawImage(img2, A, B, w, h)

            canvas.toBlob(blob => { saveAs(blob, 'geogaming-certificate.jpg') })
            // this.imageRawCertificate = canvas.toDataURL()
            this.isImageGenerated = true
          })
        }
      },
    }
</script>

<style scoped>
    .centered-table-content {
        vertical-align: middle;
    }

    .cell--profile-picture img {
        max-width: 60px;
        max-height: 60px;
        border-radius: 50%;
    }
</style>
